enum ESportType {
    Undefined = 0,
    Tennis = 1,
    BasketBall = 2,
    Chess = 3,
    GrassHockey = 4,
    Futsal = 5,
    Snooker = 6,
    Ragby = 7,
    Kerling = 8,
    Darts = 9,
    Gandball = 10,
    Volleyball = 11,
    WaterPolo = 12,
    SingleCombats = 13,
    Baseball = 14,
    AmericanFootball = 15,
    Hockey = 16,
    Soccer = 17,
    Skwoosh = 18,
    Balls = 19,
    Biatlon = 20,
    Cricket = 21,
    BikeSport = 22,
    F1 = 23,
    AlpineSkies = 24,
    CyberSport = 25,
    IceSkating = 26,
    Culture = 27,
    LightAthletics = 28,
    TableTennis = 29,
    BeachVolleyball = 30,
    BeachGandball = 31,
    BeachFootball = 32,
    Politics = 33,
    Poker = 34,
    TrampolineJumping = 35,
    FigureSkating = 36,
    FloorBall = 37,
    Bandy = 38,
    AutoMotoSport = 39,
    Badminton = 40,
    Billiard = 41,
    Ski = 42,
    Loteries = 43,
    AustralianFootball = 44,
    AIGames = 45,
    Olympiad = 46,
    NordicCombined = 47,
    MixedMartialArts = 48,
    Rowing = 49,
    Universiada = 50,
    Golf = 51,
    TankBiatlon = 52,
    EuropeanGames = 53,
    MiniFootball = 54,
    IndoorHockey = 55,
    Aquastic = 56,
    Exclusive = 57,
    GreyHound = 58,
    HorceRacing = 59,
    Trotting = 60,
    Sumo = 64,
    MuayThai = 65,
    Basketball3x3 = 66,
    ShortHockey = 67,
    CyberSoccerFifa = 68,
    CyberBasketball = 69,
    Netball = 70,
    CyberTennis = 71,
    HamsterSport = 72,
    CyberHockey = 73,
    Lacrosse = 74,
    Miscellaneous = 75,
    SpecialBets = 76,
    Checkers = 77,
    Pesapallo = 78,
    GaelicFootball = 79,
    Hurling = 80,
    QuickGames = 81,
    Bowling = 82,
    Sailing = 83,
    Boxing = 84,
    TableFootball = 85,
    Formula2 = 86,
    Skeleton = 87,
    Bobsleigh = 88,
    Luge = 89,
    Triatlon = 90,
    Headis = 91,
    Weightlifting = 92,
    Polo = 93,
    Softball = 94,
    ActionIceHockey = 95,
    ActionFootball = 96,
    ActionTennis = 97,
    RollerHockey = 98,
    Trampolining = 99,
    ModernPentathlon = 100,
    Gymnastics = 101,
    Shooting = 102,
    Fencing = 103,
    SportClimbing = 104,
    Skateboarding = 106,
    Archery = 107,
    AlternativeFootball = 108,
    AlternativeIceHockey = 109,
    ExpressOfTheDay = 110,
    AquaticSports = 112,
    Rowing2 = 114,
    ShootingSport = 115,
    Surfing = 116,
    Snowboard = 117,
    ShortTrack = 118,
    Freestyle = 119,
    Kabaddi = 120,
    Teqball = 121,
    ArmWrestling = 122,
    SepakTakraw = 131,
    TableBasketball = 132,
    Klask = 133,
    Pilota = 134,
    AirHockey = 135,
    KokBoru = 136,
    SnowVolleyball = 137,
    Padel = 138,
    BallHockey = 139,
    Frisbee = 140,
    Hot = 999999,
}

enum ESportName {
    Undefined = 'Неизвестно',
    Tennis = 'Теннис',
    BasketBall = 'Баскетбол',
    Chess = 'Шахматы',
    GrassHockey = 'Хоккей на траве',
    Futsal = 'Футзал',
    Snooker = 'Снукер',
    Ragby = 'Регби',
    Kerling = 'Керлинг',
    Darts = 'Дартс',
    Gandball = 'Гандбол',
    Volleyball = 'Волейбол',
    WaterPolo = 'Водное поло',
    SingleCombats = 'Единоборства',
    Baseball = 'Бейсбол',
    AmericanFootball = 'Американский футбол',
    Hockey = 'Хоккей',
    Soccer = 'Футбол',
    Skwoosh = 'Сквош',
    Balls = 'Шары',
    Biatlon = 'Биатлон',
    Cricket = 'Крикет',
    BikeSport = 'Велоспорт',
    F1 = 'Формула 1',
    AlpineSkies = 'Горные лыжи',
    CyberSport = 'Киберспорт',
    IceSkating = 'Конькобежный спорт',
    Culture = 'Культура',
    LightAthletics = 'Легкая атлетика',
    TableTennis = 'Настольный теннис',
    BeachVolleyball = 'Пляжный волейбол',
    BeachGandball = 'Пляжный гандбол',
    BeachFootball = 'Пляжный футбол',
    Politics = 'Политика',
    Poker = 'Покер',
    TrampolineJumping = 'Прыжки с трамплина',
    FigureSkating = 'Фигурное катание',
    FloorBall = 'Флорбол',
    Bandy = 'Хоккей с мячом',
    AutoMotoSport = 'Авто-мото спорт',
    Badminton = 'Бадминтон',
    Billiard = 'Бильярд',
    Ski = 'Лыжи',
    Loteries = 'Лотереи',
    AustralianFootball = 'Австралийский футбол',
    AIGames = 'AI GAMES',
    Olympiad = 'Олимпиада',
    NordicCombined = 'Лыжное двоеборье',
    MixedMartialArts = 'Смешанные единоборства',
    Rowing = 'Академическая гребля',
    Universiada = 'Универсиада',
    Golf = 'Гольф',
    TankBiatlon = 'Танковый биатлон',
    EuropeanGames = 'Европейские игры',
    MiniFootball = 'Мини-футбол',
    IndoorHockey = 'Хоккей на траве в залах',
    Aquastic = 'Водные виды',
    Exclusive = 'Специальные события',
    GreyHound = 'Собачьи бега',
    HorceRacing = 'Скачки',
    Trotting = 'Рысистые бега',
    Sumo = 'Сумо',
    MuayThai = 'Тайский бокс',
    Basketball3x3 = 'Баскетбол 3X3',
    ShortHockey = 'Шорт-хоккей',
    CyberSoccerFifa = 'Киберфутбол',
    CyberBasketball = 'Кибербаскетбол',
    Netball = 'Нетбол',
    CyberTennis = 'Кибертеннис',
    HamsterSport = 'Хомячий спорт',
    CyberHockey = 'Киберхоккей',
    Lacrosse = 'Лакросс',
    Miscellaneous = 'Разное',
    SpecialBets = 'Специальные ставки',
    Checkers = 'Шашки',
    Pesapallo = 'Песапалло',
    GaelicFootball = 'Гэльский футбол',
    Hurling = 'Хёрлинг',
    QuickGames = 'QuickGames',
    Bowling = 'Боулинг',
    Sailing = 'Парусный спорт',
    Boxing = 'Бокс',
    TableFootball = 'Настольный футбол',
    Formula2 = 'Формула 2',
    Skeleton = 'Скелетон',
    Bobsleigh = 'Бобслей',
    Luge = 'Санный спорт',
    Triatlon = 'Триатлон',
    Headis = 'Хэдис',
    Weightlifting = 'Тяжелая атлетика',
    Polo = 'Поло',
    Softball = 'Софтбол',
    ActionIceHockey = 'АКЦИЯ: Хоккей',
    ActionFootball = 'АКЦИЯ: Футбол',
    ActionTennis = 'АКЦИЯ: Теннис',
    RollerHockey = 'Хоккей на роликах',
    Trampolining = 'Прыжки на батуте',
    ModernPentathlon = 'Современное пятиборье',
    Gymnastics = 'Гимнастика',
    Shooting = 'Стрельба',
    Fencing = 'Фехтование',
    SportClimbing = 'Спортивное скалолазание',
    Skateboarding = 'Скейтбординг',
    Archery = 'Стрельба из лука',
    AlternativeFootball = 'Футбол альтернативный',
    AlternativeIceHockey = 'Хоккей альтернативный',
    ExpressOfTheDay = 'Экспресс дня',
    AquaticSports = 'Водные виды спорта',
    Rowing2 = 'Гребля',
    ShootingSport = 'Стрелковый спорт',
    Surfing = 'Серфинг',
    Snowboard = 'Сноуборд',
    ShortTrack = 'Шорт-трек',
    Freestyle = 'Фристайл',
    Kabaddi = 'Каббади',
    Teqball = 'Текбол',
    ArmWrestling = 'Армрестлинг',
    SepakTakraw = 'Сепактакрау',
    TableBasketball = 'Настольный баскетбол',
    Klask = 'Класк',
    Pilota = 'Пелота',
    AirHockey = 'Аэрохоккей',
    KokBoru = 'Кок-бору',
    SnowVolleyball = 'Волейбол на снегу',
    Padel = 'Падел',
    BallHockey = 'Хоккейбол',
    Frisbee = 'Фрисби',
    Hot = 'Горячее. Виртуальная группа.',
}

const SportsWithPhotos = new Set([
    1,
    3,
    6,
    9,
    13,
    18,
    19,
    20,
    22,
    23,
    24,
    26,
    28,
    35,
    36,
    39,
    41,
    42,
    47,
    48,
    51,
    56,
    64,
    65,
    77,
    84,
    86,
    87,
    89,
    90,
    91,
    92,
    100,
    101,
    102,
    103,
    104,
    106,
    107,
    112,
    114,
    115,
    116,
    117,
    118,
    119,
    122,
    135,
    138,
    144
]);


export {
    ESportType,
    ESportName,
    SportsWithPhotos,
}